import {
  getTodaySalesByType,
  getYdSalesByType,
  getMSalesByType,
  getLMSalesByType,
  getLastSales,
  searchSales
} from '@/api/transaction'

const state = {
  DSales: {
    data: [],
    sum: 0
  },
  YDSales: {
    data: [],
    sum: 0
  },
  MSales: {
    data: [],
    sum: 0
  },
  LMSales: {
    data: [],
    sum: 0
  },
  lastSales: [],
  salesLoaded: false,
  searchResult: []
}

const mutations = {
  setCompanyId(state, payload) {
    state.company_id = payload
  },
  setDSales(state, payload) {
    state.DSales = payload
  },
  setYDSales(state, payload) {
    state.YDSales = payload
  },
  setMSales(state, payload) {
    state.MSales = payload
  },
  setLMSales(state, payload) {
    state.LMSales = payload
  },
  setLastSales(state, payload) {
    state.lastSales = payload
  },
  setSalesLoaded(state, payload) {
    state.salesLoaded = payload
  },
  setSearchResult(state, payload) {
    state.searchResult = payload
  }
}

const actions = {
  async getSalesByDate({ commit }) {
    const DSales = await getTodaySalesByType()
    const YDSales = await getYdSalesByType()
    const MSales = await getMSalesByType()
    const LMSales = await getLMSalesByType()
    const lastSales = await getLastSales()
    commit('setDSales', DSales)
    commit('setYDSales', YDSales)
    commit('setMSales', MSales)
    commit('setLMSales', LMSales)
    commit('setLastSales', lastSales)
    commit('setSalesLoaded', true)
  },

  async getSalesByCompany({ commit }) { },

  async convertSalesToChart({ commit }, { sales, option }) {
    const data = []
    const condition = {
      cash: '現金支付',
      mobile: '行動支付',
      ecard: '票卡支付'
    }
    for (const item in condition) {
      const sumData = {
        value: 0,
        name: condition[item]
      }
      try {
        sumData.value = sales[item].sum
      } catch (error) { }
      data.push(sumData)
    }
    const chart = {
      type: option.type,
      radius: option.radius,
      roseType: option.roseType,
      data
    }
    return chart
  },

  async searchSales({ commit }, condition) {
    const result = await searchSales(condition)
    commit('setSearchResult', result)
  }
}

function convertSalesToChart(sales) {
  const data = []
  const condition = {
    cash: '現金支付',
    mobile: '行動支付',
    ecard: '票卡支付'
  }
  for (const item in condition) {
    const sumData = {
      value: 0,
      name: condition[item]
    }
    try {
      sumData.value = sales[item].sum
    } catch (error) { }
    data.push(sumData)
  }
  return data
}

function payTypeConvert(type) {
  switch (type) {
    case 'cash':
      return '現金'
    case 'easycard':
      return '悠遊卡'

    case 'ipass':
      return '一卡通'
    case 'creditcard':
      return '信用卡'
    case 'jkos':
      return '街口支付'
    case 'line':
      return 'LINE Pay'
    case 'gama':
      return '橘子支'
    case 'pi':
      return 'Pi錢包'
    case 'ali':
      return '支付寶'
    case 'wallet':
      return '玉山錢包'
    case 'pxpay':
      return '全支付'
    case 'family':
      return '全盈支付'

    default:
      return '數位支付'
  }
}

const getters = {
  lastSales(state) {
    return state.lastSales
  },
  DSales(state) {
    return state.DSales
  },
  YDSales(state) {
    return state.YDSales
  },
  MSales(state) {
    return state.MSales
  },
  LMSales(state) {
    return state.LMSales
  },
  salesLoaded(state) {
    return state.salesLoaded
  },
  LMChart(state) {
    return convertSalesToChart(state.LMSales)
  },
  MChart(state) {
    return convertSalesToChart(state.MSales)
  },
  DChart(state) {
    return convertSalesToChart(state.DSales)
  },
  YDChart(state) {
    return convertSalesToChart(state.YDSales)
  },
  searchResult(state) {
    return state.searchResult
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
